<template>
  <div class="content-container">
    <search-section ref="searchSection" @search="onSearch" />

    <div class="grid-scroll mt-10">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        :auto-select-first-row="false"
        class="agGrid"
        :row-multi-select-with-click="true"
        @rowClicked="onRowClick"
        @selectionChanged="onSelectRow"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers mb-0">
      <button class="btn primary small" @click="onCreateCustomer">
        {{ $t('config.profile.common.add') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRow.length !== 1"
        @click="onUpdateCustomer"
      >
        {{ $t('config.profile.common.edit') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRow.length < 2"
        @click="mergeTableDialog"
      >
        {{ $t('config.profile.common.merge') }}
      </button>
      <button class="btn primary small" @click="fnGetListTravellerExcel">
        {{ $t('config.profile.common.exportExcel') }}
      </button>
      <button
        class="btn primary small outline"
        :disabled="selectedRow.length < 1"
        @click="fnDeleteTraveller"
      >
        {{ $t('config.profile.common.delete') }}
      </button>
    </div>

    <FormDialog
      ref="FormDialog"
      :visible="dialogFormVisible"
      :profile-id="selectedRow.length === 1 ? selectedRow[0]?.id : null"
      :is-edit="isEdit"
      @cancel="onCloseCustomerDialog"
      @resetSearch="onResetSearch"
    />
    <merge-dialog
      v-model="mergeTableVisible"
      :selected-list="selectedRow"
      @resetSearch="onResetSearch"
    />
  </div>
</template>

<script>
/* eslint-disable */
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import SearchSection from './components/SearchSection.vue'
import FormDialog from './components/FormDialog.vue'
import MergeDialog from './components/MergeDialog.vue'

import paginationMixin from '@/mixins/paginationMixin'

import {
  deleteTravellerApi,
  getTravellerExcelApi,
  getTravellerListApi,
  getMergeProfileApi
} from '@/api/configuration/profile/traveller'

export default {
  components: {
    SingleCalendar,
    SearchSection,
    FormDialog,
    MergeDialog
  },
  mixins: [paginationMixin],
  data() {
    return {
      selectedRow: [],
      rows: [],

      dialogFormVisible: false,
      mergeTableVisible: false,

      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        idCardOrVisa: null,
        email: null,
        address: null,
        phoneNumber: null,
        nationId: null, // id - number
        name: null
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          headerName: '',
          field: '',
          minWidth: 50,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('config.profile.field.profileCode'),
          field: 'code',
          // cellClass: 'grid-cell-centered',
          cellStyle: params => {}
        },
        {
          headerName: this.$t('config.profile.field.lastName'),
          field: 'last_name'
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('config.profile.field.firstName'),
          field: 'first_name'
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('config.profile.field.vocative'),
          field: 'name'
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('config.profile.field.gender'),
          field: 'sex',
          valueFormatter(params) {
            switch (params.value) {
              case 1:
                return 'Nam'
              case 2:
                return 'Nữ'
              default:
                return 'Không xác định'
            }
          }
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('config.profile.field.birth'),
          field: 'birth',
          valueFormatter: params => {
            return params.value
              ? this.$moment(params.value).format('Y-MM-DD')
              : ''
          }
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('config.profile.field.nationality'),
          field: 'nationality'
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: `${this.$t('config.profile.field.passport')} / ${this.$t(
            'config.profile.field.idCard'
          )}`,
          field: 'id_card'
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('config.profile.field.phone'),
          field: 'phone_number'
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('config.profile.field.email'),
          field: 'email'
          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('config.profile.field.address'),
          field: 'address_1'
          // cellClass: 'grid-cell-centered'
        }
      ]
    }
  },
  watch: {
    dialogFormVisible(nv, ov) {
      // if dialog is close
      if (!nv) {
        this.isEdit = false
      }
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.fnGetListTraveller()
  },

  methods: {
    onCreateCustomer() {
      this.selectedRow.length = 0
      this.dialogFormVisible = true
      this.$refs.agGrid.gridOptions.api.deselectAll()
    },
    async onUpdateCustomer() {
      this.dialogFormVisible = true
    },
    onRowClick(index) {},
    onDoubleClicked(rows) {
      // similar with click sua ho so
    },
    onSelectRow(value) {
      this.selectedRow = value
    },

    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetListTraveller()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetListTraveller()
    },
    onCloseCustomerDialog() {
      this.dialogFormVisible = false
      this.fnGetListTraveller()
    },
    onResetSearch() {
      this.searchParams = {
        idCardOrVisa: null,
        email: null,
        address: null,
        phoneNumber: null,
        nationId: null, // id - number
        name: null
      }
      this.pageParams = {
        pageNum: 1,
        pageSize: 10,
        totalPage: null,
        orderBy: null,
        orderTp: null // 'asc' or 'desc'
      }
      this.fnGetListTraveller()
    },

    mergeTableDialog() {
      if (this.selectedRow.length > 5) {
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.exceed5ProfileToMerge`)
        })
        return
      }
      this.fnGetMergeProfile(this.selectedRow.map(item => item.id))
    },

    onSearch(searchParams) {
      this.searchParams = { ...searchParams }
      this.pageParams.pageNum = 1
      this.fnGetListTraveller()
    },

    // handle call api
    fnGetListTraveller() {
      let query = {
        pageSize: this.pageParams.pageSize,
        pageNum: this.pageParams.pageNum,
        orderBy: this.pageParams.orderBy,
        orderTp: this.pageParams.orderTp,
        ...this.searchParams
      }
      getTravellerListApi(query)
        .then(data => {
          if (!data.is_error) {
            this.rows = data.data
            this.pageParams.totalPage = Math.ceil(data.total / data.page_size)
            this.pageParams.pageNum = data.page_num
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    fnGetMergeProfile(profileIds) {
      getMergeProfileApi(profileIds)
        .then(data => {
          if (!data.is_error) {
            this.selectedRow = [...data.data]
            this.mergeTableVisible = true
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    fnGetListTravellerExcel() {
      this.searchParams = this.$refs.searchSection.searchParams
      let query = {
        orderBy: this.pageParams.orderBy,
        orderTp: this.pageParams.orderTp,
        ...this.searchParams
      }
      getTravellerExcelApi(query)
        .then(res => {
          if (!res.is_error) {
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'traveller-profile.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) //or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    fnDeleteTraveller() {
      if (this.selectedRow.length <= 0) {
        this.$alert(this.$t('config.profile.vxConfirm.alert'), 'Error', {
          confirmButtonText: this.$t('config.profile.common.confirmBtnText')
        })
        return
      }
      this.$vxConfirm(this.$t('config.profile.vxConfirm.delete'), () => {
        deleteTravellerApi(this.selectedRow.map(row => row.id))
          .then(data => {
            if (!data.is_error) {
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${data.message}`)
              })

              this.onResetSearch()
            } else {
              throw new Error(data)
            }
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
          .finally(() => {})
      })
    }
  }
}
</script>
